<app-edit-trip-v2-modal #editTripModal (tripUpdated)="onTripUpdated($event)"></app-edit-trip-v2-modal>

<app-add-trip-v2-modal #addTripModal (tripAdded)="onTripAdded($event)" [muvEnabled]="muvEnabled"></app-add-trip-v2-modal>
